/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AuthService } from './services/AuthService';
import { BarcodesService } from './services/BarcodesService';
import { BinsService } from './services/BinsService';
import { InventoryService } from './services/InventoryService';
import { ItemsService } from './services/ItemsService';
import { UsersService } from './services/UsersService';
import { WarehousesService } from './services/WarehousesService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class WarehouseClient {
    public readonly auth: AuthService;
    public readonly barcodes: BarcodesService;
    public readonly bins: BinsService;
    public readonly inventory: InventoryService;
    public readonly items: ItemsService;
    public readonly users: UsersService;
    public readonly warehouses: WarehousesService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'http://127.0.0.1:8788',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.auth = new AuthService(this.request);
        this.barcodes = new BarcodesService(this.request);
        this.bins = new BinsService(this.request);
        this.inventory = new InventoryService(this.request);
        this.items = new ItemsService(this.request);
        this.users = new UsersService(this.request);
        this.warehouses = new WarehousesService(this.request);
    }
}

